import { render, staticRenderFns } from "./compDetail.vue?vue&type=template&id=f63bd092"
import script from "./compDetail.vue?vue&type=script&lang=js"
export * from "./compDetail.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports